// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"463":"997a4bbf","777":"57767b71","842":"c146d16a"}[chunkId] + ".css";
};